import { useMemo } from "react";
import StyledQRCode from "../components/StyledQRCode";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useEffect, useState, useRef } from "react";
import "./Profile.css";
import { checkAuthToken } from "../AuthenticationData.ts";
import { GetProfilesFromLink } from "../ProfileData.ts";
import { toast } from "react-toastify";
import axios from "axios";
import { useProfile } from "../Context/ProfileContext";
import { UseCoupon, ReserveCoupon, GetRatingHistory } from "../CouponsData.ts";
import { useNavigate } from "react-router-dom";
import { PostView, PostClick } from "../AnalyticsData.ts";
import RatingDialog from "./RatingDialog";
import CheckoutReserved from "../sections/@dashboard/Coupons/CheckoutReserved";
import AiAdDialog from "../components/AiAdDialog";
import {
  Box,
  CircularProgress,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
  Card,
  CardContent,
  Avatar,
  Divider,
  DialogActions,
  Autocomplete,
  TextField,
  InputAdornment,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import CloseIcon from "@mui/icons-material/Close";
import PortraitIcon from "@mui/icons-material/Portrait";
import { Helmet } from "react-helmet-async";
import FitAnalyzerDialog from "./FitAnalyzerDialog";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);

    if (media.addEventListener) {
      media.addEventListener("change", listener);
    } else {
      media.addListener(listener);
    }

    return () => {
      if (media.removeEventListener) {
        media.removeEventListener("change", listener);
      } else {
        media.removeListener(listener);
      }
    };
  }, [query]);

  return matches;
};

const chunkArray = (array, size) => {
  const chunkedArr = [];
  for (let i = 0; i < array.length; i += size) {
    chunkedArr.push(array.slice(i, i + size));
  }
  return chunkedArr;
};

// Contact Exchange: countries (keep list short, fast, and safe)
// IMPORTANT: Israel is intentionally excluded (+972 / Israel)
const visitorCountryCodesRaw = [
  {
    code: "+93",
    country: "Afghanistan",
    flag: "https://flagcdn.com/w20/af.png",
  },
  { code: "+355", country: "Albania", flag: "https://flagcdn.com/w20/al.png" },
  { code: "+213", country: "Algeria", flag: "https://flagcdn.com/w20/dz.png" },
  { code: "+376", country: "Andorra", flag: "https://flagcdn.com/w20/ad.png" },
  { code: "+244", country: "Angola", flag: "https://flagcdn.com/w20/ao.png" },
  {
    code: "+1",
    country: "Antigua and Barbuda",
    flag: "https://flagcdn.com/w20/ag.png",
  },
  { code: "+54", country: "Argentina", flag: "https://flagcdn.com/w20/ar.png" },
  { code: "+374", country: "Armenia", flag: "https://flagcdn.com/w20/am.png" },
  { code: "+61", country: "Australia", flag: "https://flagcdn.com/w20/au.png" },
  { code: "+43", country: "Austria", flag: "https://flagcdn.com/w20/at.png" },
  {
    code: "+994",
    country: "Azerbaijan",
    flag: "https://flagcdn.com/w20/az.png",
  },
  { code: "+1", country: "Bahamas", flag: "https://flagcdn.com/w20/bs.png" },
  { code: "+973", country: "Bahrain", flag: "https://flagcdn.com/w20/bh.png" },
  {
    code: "+880",
    country: "Bangladesh",
    flag: "https://flagcdn.com/w20/bd.png",
  },
  { code: "+1", country: "Barbados", flag: "https://flagcdn.com/w20/bb.png" },
  { code: "+375", country: "Belarus", flag: "https://flagcdn.com/w20/by.png" },
  { code: "+32", country: "Belgium", flag: "https://flagcdn.com/w20/be.png" },
  { code: "+501", country: "Belize", flag: "https://flagcdn.com/w20/bz.png" },
  { code: "+229", country: "Benin", flag: "https://flagcdn.com/w20/bj.png" },
  { code: "+975", country: "Bhutan", flag: "https://flagcdn.com/w20/bt.png" },
  { code: "+591", country: "Bolivia", flag: "https://flagcdn.com/w20/bo.png" },
  {
    code: "+387",
    country: "Bosnia and Herzegovina",
    flag: "https://flagcdn.com/w20/ba.png",
  },
  { code: "+267", country: "Botswana", flag: "https://flagcdn.com/w20/bw.png" },
  { code: "+55", country: "Brazil", flag: "https://flagcdn.com/w20/br.png" },
  { code: "+673", country: "Brunei", flag: "https://flagcdn.com/w20/bn.png" },
  { code: "+359", country: "Bulgaria", flag: "https://flagcdn.com/w20/bg.png" },
  {
    code: "+226",
    country: "Burkina Faso",
    flag: "https://flagcdn.com/w20/bf.png",
  },
  { code: "+257", country: "Burundi", flag: "https://flagcdn.com/w20/bi.png" },
  { code: "+855", country: "Cambodia", flag: "https://flagcdn.com/w20/kh.png" },
  { code: "+237", country: "Cameroon", flag: "https://flagcdn.com/w20/cm.png" },
  { code: "+1", country: "Canada", flag: "https://flagcdn.com/w20/ca.png" },
  {
    code: "+238",
    country: "Cape Verde",
    flag: "https://flagcdn.com/w20/cv.png",
  },
  {
    code: "+236",
    country: "Central African Republic",
    flag: "https://flagcdn.com/w20/cf.png",
  },
  { code: "+235", country: "Chad", flag: "https://flagcdn.com/w20/td.png" },
  { code: "+56", country: "Chile", flag: "https://flagcdn.com/w20/cl.png" },
  { code: "+86", country: "China", flag: "https://flagcdn.com/w20/cn.png" },
  { code: "+57", country: "Colombia", flag: "https://flagcdn.com/w20/co.png" },
  { code: "+269", country: "Comoros", flag: "https://flagcdn.com/w20/km.png" },
  {
    code: "+242",
    country: "Congo (Brazzaville)",
    flag: "https://flagcdn.com/w20/cg.png",
  },
  {
    code: "+243",
    country: "Congo (Kinshasa)",
    flag: "https://flagcdn.com/w20/cd.png",
  },
  {
    code: "+506",
    country: "Costa Rica",
    flag: "https://flagcdn.com/w20/cr.png",
  },
  { code: "+385", country: "Croatia", flag: "https://flagcdn.com/w20/hr.png" },
  { code: "+53", country: "Cuba", flag: "https://flagcdn.com/w20/cu.png" },
  { code: "+357", country: "Cyprus", flag: "https://flagcdn.com/w20/cy.png" },
  {
    code: "+420",
    country: "Czech Republic",
    flag: "https://flagcdn.com/w20/cz.png",
  },
  { code: "+45", country: "Denmark", flag: "https://flagcdn.com/w20/dk.png" },
  { code: "+253", country: "Djibouti", flag: "https://flagcdn.com/w20/dj.png" },
  { code: "+1", country: "Dominica", flag: "https://flagcdn.com/w20/dm.png" },
  {
    code: "+1",
    country: "Dominican Republic",
    flag: "https://flagcdn.com/w20/do.png",
  },
  {
    code: "+670",
    country: "East Timor",
    flag: "https://flagcdn.com/w20/tl.png",
  },
  { code: "+593", country: "Ecuador", flag: "https://flagcdn.com/w20/ec.png" },
  { code: "+20", country: "Egypt", flag: "https://flagcdn.com/w20/eg.png" },
  {
    code: "+503",
    country: "El Salvador",
    flag: "https://flagcdn.com/w20/sv.png",
  },
  {
    code: "+240",
    country: "Equatorial Guinea",
    flag: "https://flagcdn.com/w20/gq.png",
  },
  { code: "+291", country: "Eritrea", flag: "https://flagcdn.com/w20/er.png" },
  { code: "+372", country: "Estonia", flag: "https://flagcdn.com/w20/ee.png" },
  { code: "+268", country: "Eswatini", flag: "https://flagcdn.com/w20/sz.png" },
  { code: "+251", country: "Ethiopia", flag: "https://flagcdn.com/w20/et.png" },
  { code: "+679", country: "Fiji", flag: "https://flagcdn.com/w20/fj.png" },
  { code: "+358", country: "Finland", flag: "https://flagcdn.com/w20/fi.png" },
  { code: "+33", country: "France", flag: "https://flagcdn.com/w20/fr.png" },
  { code: "+241", country: "Gabon", flag: "https://flagcdn.com/w20/ga.png" },
  { code: "+220", country: "Gambia", flag: "https://flagcdn.com/w20/gm.png" },
  { code: "+995", country: "Georgia", flag: "https://flagcdn.com/w20/ge.png" },
  { code: "+49", country: "Germany", flag: "https://flagcdn.com/w20/de.png" },
  { code: "+233", country: "Ghana", flag: "https://flagcdn.com/w20/gh.png" },
  { code: "+30", country: "Greece", flag: "https://flagcdn.com/w20/gr.png" },
  { code: "+1", country: "Grenada", flag: "https://flagcdn.com/w20/gd.png" },
  {
    code: "+502",
    country: "Guatemala",
    flag: "https://flagcdn.com/w20/gt.png",
  },
  { code: "+224", country: "Guinea", flag: "https://flagcdn.com/w20/gn.png" },
  {
    code: "+245",
    country: "Guinea-Bissau",
    flag: "https://flagcdn.com/w20/gw.png",
  },
  { code: "+592", country: "Guyana", flag: "https://flagcdn.com/w20/gy.png" },
  { code: "+509", country: "Haiti", flag: "https://flagcdn.com/w20/ht.png" },
  { code: "+504", country: "Honduras", flag: "https://flagcdn.com/w20/hn.png" },
  { code: "+36", country: "Hungary", flag: "https://flagcdn.com/w20/hu.png" },
  { code: "+354", country: "Iceland", flag: "https://flagcdn.com/w20/is.png" },
  { code: "+91", country: "India", flag: "https://flagcdn.com/w20/in.png" },
  { code: "+62", country: "Indonesia", flag: "https://flagcdn.com/w20/id.png" },
  { code: "+98", country: "Iran", flag: "https://flagcdn.com/w20/ir.png" },
  { code: "+964", country: "Iraq", flag: "https://flagcdn.com/w20/iq.png" },
  { code: "+353", country: "Ireland", flag: "https://flagcdn.com/w20/ie.png" },
  { code: "+39", country: "Italy", flag: "https://flagcdn.com/w20/it.png" },
  {
    code: "+225",
    country: "Ivory Coast",
    flag: "https://flagcdn.com/w20/ci.png",
  },
  { code: "+1", country: "Jamaica", flag: "https://flagcdn.com/w20/jm.png" },
  { code: "+81", country: "Japan", flag: "https://flagcdn.com/w20/jp.png" },
  { code: "+962", country: "Jordan", flag: "https://flagcdn.com/w20/jo.png" },
  { code: "+7", country: "Kazakhstan", flag: "https://flagcdn.com/w20/kz.png" },
  { code: "+254", country: "Kenya", flag: "https://flagcdn.com/w20/ke.png" },
  { code: "+686", country: "Kiribati", flag: "https://flagcdn.com/w20/ki.png" },
  { code: "+965", country: "Kuwait", flag: "https://flagcdn.com/w20/kw.png" },
  {
    code: "+996",
    country: "Kyrgyzstan",
    flag: "https://flagcdn.com/w20/kg.png",
  },
  { code: "+856", country: "Laos", flag: "https://flagcdn.com/w20/la.png" },
  { code: "+371", country: "Latvia", flag: "https://flagcdn.com/w20/lv.png" },
  { code: "+961", country: "Lebanon", flag: "https://flagcdn.com/w20/lb.png" },
  { code: "+266", country: "Lesotho", flag: "https://flagcdn.com/w20/ls.png" },
  { code: "+231", country: "Liberia", flag: "https://flagcdn.com/w20/lr.png" },
  { code: "+218", country: "Libya", flag: "https://flagcdn.com/w20/ly.png" },
  {
    code: "+423",
    country: "Liechtenstein",
    flag: "https://flagcdn.com/w20/li.png",
  },
  {
    code: "+370",
    country: "Lithuania",
    flag: "https://flagcdn.com/w20/lt.png",
  },
  {
    code: "+352",
    country: "Luxembourg",
    flag: "https://flagcdn.com/w20/lu.png",
  },
  {
    code: "+261",
    country: "Madagascar",
    flag: "https://flagcdn.com/w20/mg.png",
  },
  { code: "+265", country: "Malawi", flag: "https://flagcdn.com/w20/mw.png" },
  { code: "+60", country: "Malaysia", flag: "https://flagcdn.com/w20/my.png" },
  { code: "+960", country: "Maldives", flag: "https://flagcdn.com/w20/mv.png" },
  { code: "+223", country: "Mali", flag: "https://flagcdn.com/w20/ml.png" },
  { code: "+356", country: "Malta", flag: "https://flagcdn.com/w20/mt.png" },
  {
    code: "+692",
    country: "Marshall Islands",
    flag: "https://flagcdn.com/w20/mh.png",
  },
  {
    code: "+222",
    country: "Mauritania",
    flag: "https://flagcdn.com/w20/mr.png",
  },
  {
    code: "+230",
    country: "Mauritius",
    flag: "https://flagcdn.com/w20/mu.png",
  },
  { code: "+52", country: "Mexico", flag: "https://flagcdn.com/w20/mx.png" },
  {
    code: "+691",
    country: "Micronesia",
    flag: "https://flagcdn.com/w20/fm.png",
  },
  { code: "+373", country: "Moldova", flag: "https://flagcdn.com/w20/md.png" },
  { code: "+377", country: "Monaco", flag: "https://flagcdn.com/w20/mc.png" },
  { code: "+976", country: "Mongolia", flag: "https://flagcdn.com/w20/mn.png" },
  {
    code: "+382",
    country: "Montenegro",
    flag: "https://flagcdn.com/w20/me.png",
  },
  { code: "+212", country: "Morocco", flag: "https://flagcdn.com/w20/ma.png" },
  {
    code: "+258",
    country: "Mozambique",
    flag: "https://flagcdn.com/w20/mz.png",
  },
  { code: "+95", country: "Myanmar", flag: "https://flagcdn.com/w20/mm.png" },
  { code: "+264", country: "Namibia", flag: "https://flagcdn.com/w20/na.png" },
  { code: "+674", country: "Nauru", flag: "https://flagcdn.com/w20/nr.png" },
  { code: "+977", country: "Nepal", flag: "https://flagcdn.com/w20/np.png" },
  {
    code: "+31",
    country: "Netherlands",
    flag: "https://flagcdn.com/w20/nl.png",
  },
  {
    code: "+64",
    country: "New Zealand",
    flag: "https://flagcdn.com/w20/nz.png",
  },
  {
    code: "+505",
    country: "Nicaragua",
    flag: "https://flagcdn.com/w20/ni.png",
  },
  { code: "+227", country: "Niger", flag: "https://flagcdn.com/w20/ne.png" },
  { code: "+234", country: "Nigeria", flag: "https://flagcdn.com/w20/ng.png" },
  {
    code: "+850",
    country: "North Korea",
    flag: "https://flagcdn.com/w20/kp.png",
  },
  {
    code: "+389",
    country: "North Macedonia",
    flag: "https://flagcdn.com/w20/mk.png",
  },
  { code: "+47", country: "Norway", flag: "https://flagcdn.com/w20/no.png" },
  { code: "+968", country: "Oman", flag: "https://flagcdn.com/w20/om.png" },
  { code: "+92", country: "Pakistan", flag: "https://flagcdn.com/w20/pk.png" },
  { code: "+680", country: "Palau", flag: "https://flagcdn.com/w20/pw.png" },
  {
    code: "+970",
    country: "Palestine",
    flag: "https://flagcdn.com/w20/ps.png",
  },
  { code: "+507", country: "Panama", flag: "https://flagcdn.com/w20/pa.png" },
  {
    code: "+675",
    country: "Papua New Guinea",
    flag: "https://flagcdn.com/w20/pg.png",
  },
  { code: "+595", country: "Paraguay", flag: "https://flagcdn.com/w20/py.png" },
  { code: "+51", country: "Peru", flag: "https://flagcdn.com/w20/pe.png" },
  {
    code: "+63",
    country: "Philippines",
    flag: "https://flagcdn.com/w20/ph.png",
  },
  { code: "+48", country: "Poland", flag: "https://flagcdn.com/w20/pl.png" },
  { code: "+351", country: "Portugal", flag: "https://flagcdn.com/w20/pt.png" },
  { code: "+974", country: "Qatar", flag: "https://flagcdn.com/w20/qa.png" },
  { code: "+40", country: "Romania", flag: "https://flagcdn.com/w20/ro.png" },
  { code: "+7", country: "Russia", flag: "https://flagcdn.com/w20/ru.png" },
  { code: "+250", country: "Rwanda", flag: "https://flagcdn.com/w20/rw.png" },
  {
    code: "+1",
    country: "Saint Kitts and Nevis",
    flag: "https://flagcdn.com/w20/kn.png",
  },
  {
    code: "+1",
    country: "Saint Lucia",
    flag: "https://flagcdn.com/w20/lc.png",
  },
  {
    code: "+1",
    country: "Saint Vincent and the Grenadines",
    flag: "https://flagcdn.com/w20/vc.png",
  },
  { code: "+685", country: "Samoa", flag: "https://flagcdn.com/w20/ws.png" },
  {
    code: "+378",
    country: "San Marino",
    flag: "https://flagcdn.com/w20/sm.png",
  },
  {
    code: "+239",
    country: "Sao Tome and Principe",
    flag: "https://flagcdn.com/w20/st.png",
  },
  {
    code: "+966",
    country: "Saudi Arabia",
    flag: "https://flagcdn.com/w20/sa.png",
  },
  { code: "+221", country: "Senegal", flag: "https://flagcdn.com/w20/sn.png" },
  { code: "+381", country: "Serbia", flag: "https://flagcdn.com/w20/rs.png" },
  {
    code: "+248",
    country: "Seychelles",
    flag: "https://flagcdn.com/w20/sc.png",
  },
  {
    code: "+232",
    country: "Sierra Leone",
    flag: "https://flagcdn.com/w20/sl.png",
  },
  { code: "+65", country: "Singapore", flag: "https://flagcdn.com/w20/sg.png" },
  { code: "+421", country: "Slovakia", flag: "https://flagcdn.com/w20/sk.png" },
  { code: "+386", country: "Slovenia", flag: "https://flagcdn.com/w20/si.png" },
  {
    code: "+677",
    country: "Solomon Islands",
    flag: "https://flagcdn.com/w20/sb.png",
  },
  { code: "+252", country: "Somalia", flag: "https://flagcdn.com/w20/so.png" },
  {
    code: "+27",
    country: "South Africa",
    flag: "https://flagcdn.com/w20/za.png",
  },
  {
    code: "+82",
    country: "South Korea",
    flag: "https://flagcdn.com/w20/kr.png",
  },
  {
    code: "+211",
    country: "South Sudan",
    flag: "https://flagcdn.com/w20/ss.png",
  },
  { code: "+34", country: "Spain", flag: "https://flagcdn.com/w20/es.png" },
  { code: "+94", country: "Sri Lanka", flag: "https://flagcdn.com/w20/lk.png" },
  { code: "+249", country: "Sudan", flag: "https://flagcdn.com/w20/sd.png" },
  { code: "+597", country: "Suriname", flag: "https://flagcdn.com/w20/sr.png" },
  { code: "+46", country: "Sweden", flag: "https://flagcdn.com/w20/se.png" },
  {
    code: "+41",
    country: "Switzerland",
    flag: "https://flagcdn.com/w20/ch.png",
  },
  { code: "+963", country: "Syria", flag: "https://flagcdn.com/w20/sy.png" },
  { code: "+886", country: "Taiwan", flag: "https://flagcdn.com/w20/tw.png" },
  {
    code: "+992",
    country: "Tajikistan",
    flag: "https://flagcdn.com/w20/tj.png",
  },
  { code: "+255", country: "Tanzania", flag: "https://flagcdn.com/w20/tz.png" },
  { code: "+66", country: "Thailand", flag: "https://flagcdn.com/w20/th.png" },
  { code: "+228", country: "Togo", flag: "https://flagcdn.com/w20/tg.png" },
  { code: "+676", country: "Tonga", flag: "https://flagcdn.com/w20/to.png" },
  {
    code: "+1",
    country: "Trinidad and Tobago",
    flag: "https://flagcdn.com/w20/tt.png",
  },
  { code: "+216", country: "Tunisia", flag: "https://flagcdn.com/w20/tn.png" },
  { code: "+90", country: "Turkey", flag: "https://flagcdn.com/w20/tr.png" },
  {
    code: "+993",
    country: "Turkmenistan",
    flag: "https://flagcdn.com/w20/tm.png",
  },
  { code: "+688", country: "Tuvalu", flag: "https://flagcdn.com/w20/tv.png" },
  { code: "+256", country: "Uganda", flag: "https://flagcdn.com/w20/ug.png" },
  { code: "+380", country: "Ukraine", flag: "https://flagcdn.com/w20/ua.png" },
  {
    code: "+971",
    country: "United Arab Emirates",
    flag: "https://flagcdn.com/w20/ae.png",
  },
  {
    code: "+44",
    country: "United Kingdom",
    flag: "https://flagcdn.com/w20/gb.png",
  },
  {
    code: "+1",
    country: "United States",
    flag: "https://flagcdn.com/w20/us.png",
  },
  { code: "+598", country: "Uruguay", flag: "https://flagcdn.com/w20/uy.png" },
  {
    code: "+998",
    country: "Uzbekistan",
    flag: "https://flagcdn.com/w20/uz.png",
  },
  { code: "+678", country: "Vanuatu", flag: "https://flagcdn.com/w20/vu.png" },
  {
    code: "+39",
    country: "Vatican City",
    flag: "https://flagcdn.com/w20/va.png",
  },
  { code: "+58", country: "Venezuela", flag: "https://flagcdn.com/w20/ve.png" },
  { code: "+84", country: "Vietnam", flag: "https://flagcdn.com/w20/vn.png" },
  { code: "+967", country: "Yemen", flag: "https://flagcdn.com/w20/ye.png" },
  { code: "+260", country: "Zambia", flag: "https://flagcdn.com/w20/zm.png" },
  { code: "+263", country: "Zimbabwe", flag: "https://flagcdn.com/w20/zw.png" },
];

const visitorCountryCodes = visitorCountryCodesRaw
  .filter(
    (c) => c.code !== "+972" && String(c.country).toLowerCase() !== "israel",
  )
  // give each option a stable unique id (important for duplicates like +1)
  .map((c, idx) => ({ ...c, id: `${c.country}-${c.code}-${idx}` }));

const DEFAULT_COUNTRY_CODE = "+216";

const getDefaultCountry = () =>
  visitorCountryCodes.find((c) => c.code === DEFAULT_COUNTRY_CODE) ||
  visitorCountryCodes[0];

const commonInputStyle = {
  "& .MuiOutlinedInput-root": {
    height: 50,
    borderRadius: "14px",
    backgroundColor: "#fff",
    "& fieldset": {
      borderColor: "rgba(0,0,0,0.15)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2c3e50", // Matches your primary brand color
      borderWidth: "2px",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#2c3e50",
  },
  "& .MuiFormHelperText-root": {
    textAlign: "right",
    marginRight: 0,
  },
};

const Profile = () => {
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const hasRun = useRef(false);
  const { profile, fetchProfile } = useProfile();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const navigate = useNavigate();
  const [SerialKey, setSerialKey] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [Account, setAccount] = useState({
    email: "",
    firstName: "",
    id: 0,
    lastName: "",
    category: "",
    profile: {
      birthDate: "",
      customLinks: null,
      gender: "",
      id: 0,
      isPremium: false,
      occupation: "",
      premium: null,
      profileCoverPicture: "",
      profilePicture: "",
      profilePictureFrame: 0,
      socialLinks: null,
      user: null,
      userId: 0,
      userName: "",
      country: "",
    },
    auth: {
      id: 0,
      password: "",
      user: null,
      userId: 8,
    },
    contacts: [],
    rate: 0,
    rateCount: 0,
    rate_Skill_QualityOfWork: 0,
    rate_Skill_CostEffectiveness: 0,
    rate_Skill_Timeliness: 0,
    rate_Skill_Communication: 0,
    rate_Skill_Agility: 0,
  });

  const qrCodeRef = useRef(null);

  const handleQrDownload = () => {
    if (qrCodeRef.current) {
      qrCodeRef.current.download({
        name: `${Account.firstName}-${Account.lastName}-profile-qr`,
        extension: "svg",
      });
    }
  };

  const quickConnectQrOptions = useMemo(
    () => ({
      type: "svg",
      data: window.location.href,
      image: "/assets/contactie_logo.png",
      qrOptions: {
        margin: 0,
        errorCorrectionLevel: "H",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 1,
      },
      dotsOptions: {
        color: "#2c3e50",
        type: "extra-rounded",
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      cornersSquareOptions: {
        color: "#2c3e50",
        type: "extra-rounded",
      },
      cornersDotOptions: {
        color: "#2c3e50",
      },
    }),
    [window.location.href],
  );

  const shareModalQrOptions = useMemo(
    () => ({
      type: "svg",
      margin: 0,
      data: window.location.href,
      image: "/assets/contactie_logo.png",
      qrOptions: {
        margin: 0,
        errorCorrectionLevel: "H",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 1,
      },
      dotsOptions: {
        color: "#2c3e50",
        type: "extra-rounded",
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      cornersSquareOptions: {
        color: "#2c3e50",
        type: "extra-rounded",
      },
      cornersDotOptions: {
        color: "#2c3e50",
      },
    }),
    [window.location.href],
  );

  // Component state
  const [SocialLinks, setSocialLinks] = useState([]);
  const [CustomLinks, setCustomLinks] = useState([]);
  const [sameAccount, setSameAccount] = useState(false);
  const [activeTab, setActiveTab] = useState("links");

  // Modal states
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openContactModal, setOpenContactModal] = useState(false);
  const [visitorName, setVisitorName] = useState("");
  const [visitorPhone, setVisitorPhone] = useState("");
  const [visitorCountry, setVisitorCountry] = useState(getDefaultCountry);
  const [visitorEventName, setVisitorEventName] = useState("");
  const [isSharingContact, setIsSharingContact] = useState(false);
  const [openRatingDialog, setOpenRatingDialog] = useState(
    SerialKey ? true : false,
  );
  const [openReserveDialog, setOpenReserveDialog] = useState(false);
  const [openCvDialog, setOpenCvDialog] = useState(false);
  const [isRatingLoading, setIsRatingLoading] = useState(false);
  const [isReserveLoading, setIsReserveLoading] = useState(false);
  const [openBetaDialog, setOpenBetaDialog] = useState(false);
  const [showAiDialog, setShowAiDialog] = useState(false);
  const [showRatingHistory, setShowRatingHistory] = useState(false);
  const [ratingHistory, setRatingHistory] = useState([]);
  const [ratingHistoryPage, setRatingHistoryPage] = useState(1);
  const [ratingHistoryLoading, setRatingHistoryLoading] = useState(false);
  const [hasMoreRatings, setHasMoreRatings] = useState(true);
  const [openAuthDialog, setOpenAuthDialog] = useState(false);
  const cvFileRef = useRef(null);
  const [openAnalyzerDialog, setOpenAnalyzerDialog] = useState(false);

  // Tab change handler
  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
  };

  const handleApplyCoupon = async (coupon, expirationDate) => {
    setIsReserveLoading(true);
    try {
      // Input validation
      if (!coupon || typeof coupon !== "string" || coupon.trim() === "") {
        throw new Error("Please enter a valid serial key.");
      }

      const response = await ReserveCoupon(coupon.trim(), expirationDate);

      if (response.error) {
        throw new Error(response.error);
      }

      // Success message
      const successMessage =
        response.data?.message || "Coupon reserved successfully!";
      toast.success(successMessage, {
        position: "top-center",
        autoClose: 2000,
      });

      return response;
    } catch (error) {
      // Enhanced error display
      const errorMessage =
        error.message || "Failed to reserve coupon. Please try again.";
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
      });

      // Return error for component handling
      return { error: errorMessage };
    } finally {
      setIsReserveLoading(false);
    }
  };

  const fetchRatingHistory = async (page = 1, append = false) => {
    setRatingHistoryLoading(true);
    try {
      const response = await GetRatingHistory(Account.id, page, 10);

      if (response.error) {
        throw new Error(response.error);
      }

      if (append) {
        setRatingHistory((prev) => [...prev, ...response.ratings]);
      } else {
        setRatingHistory(response.ratings);
      }

      const hasMore = response.currentPage < response.totalPages;

      setHasMoreRatings(hasMore);
      setRatingHistoryPage(page);
    } catch (error) {
      console.error("Error fetching rating history:", error);
      toast.error("No rating history.", {
        position: "top-center",
        autoClose: 3000,
      });
    } finally {
      setRatingHistoryLoading(false);
    }
  };

  const loadMoreRatings = () => {
    if (!ratingHistoryLoading) {
      fetchRatingHistory(ratingHistoryPage + 1, true);
    }
  };

  const handleReachEnd = () => {
    if (hasMoreRatings && !ratingHistoryLoading) {
      loadMoreRatings();
    }
  };

  const formatRatingDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleViewCount = async (profile, profileToView) => {
    if (hasRun.current) return;

    try {
      // Create a unique session identifier for this view session
      const sessionKey = `profile_view_${profileToView.id}_${Date.now()}`;
      const lastViewKey = `last_view_${profileToView.id}`;
      const lastViewTime = localStorage.getItem(lastViewKey);

      // Prevent duplicate views within 5 minutes (300000ms)
      if (lastViewTime && Date.now() - parseInt(lastViewTime) < 300000) {
        hasRun.current = true;
        return;
      }

      const viewData = {
        userId: profileToView.id,
        date: new Date(),
      };

      let shouldRecordView = false;

      // If the user is logged in and views someone else's profile
      if (profile && profile.id && profile.id !== profileToView.id) {
        viewData.gender = profile.profile?.gender ?? null;
        viewData.country = profile.profile?.country ?? "Tunisia";
        shouldRecordView = true;
      }

      // If the user is not logged in and views a profile
      if (profile == null) {
        // For anonymous users, try to get country from browser or use default
        viewData.country = "Tunisia"; // Default country
        shouldRecordView = true;
      }

      if (shouldRecordView) {
        await PostView(viewData);
        localStorage.setItem(lastViewKey, Date.now().toString());
        hasRun.current = true;
      }
    } catch (error) {
      console.error("Error posting view:", error);
      // Don't prevent the page from loading if analytics fail
    }
  };

  useEffect(() => {
    const storedSerialKey = localStorage.getItem("serialKey");
    if (storedSerialKey) {
      setSerialKey(storedSerialKey);
      setOpenRatingDialog(true);
    }
    const fetchData = () => {
      fetchProfileData();
    };

    // Initial fetch
    fetchData();

    // Check AI dialog
    const showAi = localStorage.getItem("showAiAdDialog") === "true";
    setShowAiDialog(showAi);

    // Execute fetch every minute - COMMENTED OUT FOR NOW
    // const intervalId = setInterval(fetchData, 15000);

    // return () => {
    //   clearInterval(intervalId);
    // };
  }, [profile]);

  useEffect(() => {
    const runOnce = async () => {
      try {
        // Check if the user is authenticated
        const isAuthenticated = checkAuthToken();

        // If the user is authenticated, ensure their profile is fetched
        if (isAuthenticated && (!profile || !profile.id)) {
          await fetchProfile();
        }

        const currentPath = window.location.pathname;
        const searchQueryPart = currentPath.substring(
          currentPath.lastIndexOf("/") + 1,
        );

        // Fetch the profile associated with the current URL
        const response = await GetProfilesFromLink(searchQueryPart);
        const profileToView = response.data;

        // Determine if the authenticated user matches the profile being viewed
        if (isAuthenticated) {
          setSameAccount(profile.id === profileToView.id);
        } else {
          setSameAccount(false);
        }

        // Handle view count logic
        await handleViewCount(isAuthenticated ? profile : null, profileToView);
      } catch (error) {
        console.error("Error in runOnce:", error);
      }
    };

    runOnce();
  }, [profile]);

  useEffect(() => {
    if (openContactModal && profile && profile.id) {
      const firstName = profile.firstName || "";
      const lastName = profile.lastName || "";
      const fullName = `${firstName} ${lastName}`.trim();

      if (fullName) {
        setVisitorName(fullName);
      }

      const phoneContact = profile.contacts?.find((c) =>
        ["tel", "phone", "phonenumber", "whatsapp", "wa", "sms"].includes(
          c.category?.toLowerCase(),
        ),
      );

      if (phoneContact && phoneContact.contactInfo) {
        const rawPhone = phoneContact.contactInfo.trim();

        const sortedCodes = [...visitorCountryCodes].sort(
          (a, b) => b.code.length - a.code.length,
        );

        const matchedCountry = sortedCodes.find((c) =>
          rawPhone.startsWith(c.code),
        );

        if (matchedCountry) {
          setVisitorCountry(matchedCountry);
          const numberOnly = rawPhone.substring(matchedCountry.code.length);
          setVisitorPhone(numberOnly);
        } else {
          setVisitorPhone(rawPhone);
        }
      }
    }
  }, [openContactModal, profile]);

  const fetchProfileData = async () => {
    const currentPath = window.location.pathname;
    const searchQueryPart = currentPath.substring(
      currentPath.lastIndexOf("/") + 1,
    );
    try {
      setIsLoading(true);
      const response = await GetProfilesFromLink(searchQueryPart);
      if (response.error) {
        throw new Error(response.error);
      }

      setAccount(response.data);
      setSocialLinks(response.data.profile.socialLinks);
      setCustomLinks(response.data.profile.customLinks || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      navigate("/404");
    }
  };

  const handleSendRate = async (data) => {
    setIsRatingLoading(true);
    try {
      const response = await UseCoupon(data);
      if (response.error) throw new Error(response.error);

      localStorage.removeItem("serialKey");
      setSerialKey(null);
      toast.success("Rating submitted successfully!", {
        position: "top-center",
        autoClose: 1000,
      });
    } catch (error) {
      toast.error(error.message, {
        position: "top-center",
        autoClose: 1000,
      });
    } finally {
      setIsRatingLoading(false);
    }
    fetchProfile();
  };

  // Helper functions
  const generateStars = (score, maxStars = 5) => {
    let starsHTML = [];
    const fullStars = Math.floor(score);
    const halfStarThreshold = 0.4;
    const halfStar = score % 1 >= halfStarThreshold;
    const emptyStars = maxStars - fullStars - (halfStar ? 1 : 0);

    for (let i = 0; i < fullStars; i++) {
      starsHTML.push(<i key={`full-${i}`} className="fa-solid fa-star"></i>);
    }
    if (halfStar) {
      starsHTML.push(
        <i key="half" className="fa-solid fa-star-half-stroke"></i>,
      );
    }
    for (let i = 0; i < emptyStars; i++) {
      starsHTML.push(<i key={`empty-${i}`} className="fa-regular fa-star"></i>);
    }

    return starsHTML;
  };

  const handleLinkClick = async (linkId, linkUrl, category) => {
    // Validate URL first
    if (!validateURL(linkUrl)) {
      navigate("/404");
      return;
    }

    // For iOS, navigate immediately to avoid popup blocking
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      // Post analytics in background after navigation
      if (!sameAccount) {
        PostClick({
          linkId: linkId,
          userId: Account.id,
          gender: Account.profile?.gender ?? null,
          country: Account.profile?.country ?? null,
          category: category,
          date: new Date(),
        }).catch(console.error); // Don't await, just fire and forget
      }
      window.open(linkUrl, "_blank");
    } else {
      // For other devices, use the original approach with timeout
      setTimeout(async () => {
        if (!sameAccount) {
          await PostClick({
            linkId: linkId,
            userId: Account.id,
            gender: Account.profile?.gender ?? null,
            country: Account.profile?.country ?? null,
            category: category,
            date: new Date(),
          });
        }
        window.open(linkUrl, "_blank");
      }, 100);
    }
  };

  const validateURL = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  const handleContactClick = (type, value) => {
    let href = "#";
    const encodedValue = encodeURIComponent(value);
    const cleanTel = value.replace(/[^0-9+]/g, "");
    const cleanWa = value.replace(/[^0-9]/g, "");

    // Add a small delay to ensure touch event is properly registered on iOS
    setTimeout(() => {
      switch (type.toLowerCase()) {
        case "tel":
        case "phone":
        case "phonenumber":
          href = `tel:${cleanTel}`;
          break;
        case "wa":
        case "whatsapp":
          href = `https://wa.me/${cleanWa}`;
          // Use a more iOS-friendly approach
          if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            window.location.href = href;
          } else {
            window.open(href, "_blank");
          }
          return;
        case "mailto":
        case "email":
          href = `mailto:${value}`;
          break;
        case "gmail":
          href = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
            value,
          )}`;
          // Use a more iOS-friendly approach
          if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            window.location.href = href;
          } else {
            window.open(href, "_blank");
          }
          return;
        case "map":
          href = `https://maps.google.com/?q=${encodedValue}`;
          // Use a more iOS-friendly approach
          if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            window.location.href = href;
          } else {
            window.open(href, "_blank");
          }
          return;
        case "sms":
          href = `sms:${cleanTel}`;
          break;
        default:
          href = "#";
          break;
      }

      if (href !== "#") {
        window.location.href = href;
      }
    }, 100); // Small delay to ensure touch event completes
  };

  const validContacts =
    Account.contacts?.filter(
      (contact) =>
        contact.isPublic &&
        !contact.contactInfo?.startsWith("data:application/pdf"),
    ) || [];

  const hasValidContacts = validContacts.length > 0;
  const normalizePhone = (phone) => {
    if (!phone) return "";
    const s = String(phone).trim();
    let out = "";
    for (let i = 0; i < s.length; i++) {
      const c = s[i];
      if (c === "+" && out.length === 0) {
        out += c;
        continue;
      }
      if (c >= "0" && c <= "9") out += c;
    }
    return out;
  };

  const isValidNormalizedPhone = (phone) => {
    if (!phone) return false;
    const digits = phone.replace(/\D/g, "").length;
    if (digits < 6 || digits > 20) return false;
    if (phone.includes("+") && !phone.startsWith("+")) return false;
    return true;
  };

  const handleShareVisitorContact = async () => {
    if (isSharingContact) return;

    // prevent sending to yourself (optional but sensible)
    if (sameAccount) {
      toast.error("You can’t share contact to your own profile.", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    const name = (visitorName || "").trim();
    const nationalNumber = (visitorPhone || "").trim();
    const rawPhone = `${
      visitorCountry?.code || DEFAULT_COUNTRY_CODE
    }${nationalNumber}`;
    const event = (visitorEventName || "").trim();

    if (name.length < 2 || name.length > 80) {
      toast.error("Please enter a valid name.", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    const normalizedPhone = normalizePhone(rawPhone);
    if (!isValidNormalizedPhone(normalizedPhone)) {
      toast.error("Please enter a valid phone number.", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    if (event && event.length > 20) {
      toast.error("Event name must be 20 characters max.", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    if (event && !/^[A-Za-z0-9\s\-_.,/&()]+$/.test(event)) {
      toast.error("Event name contains invalid characters.", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    const profileUserName =
      (Account?.profile?.userName || "").trim() ||
      window.location.pathname.substring(
        window.location.pathname.lastIndexOf("/") + 1,
      );

    setIsSharingContact(true);
    try {
      await axios.post("/api/VisitorContact/Share", {
        ProfileUserName: profileUserName,
        VisitorName: name,
        VisitorPhone: normalizedPhone,
        EventName: event ? event : null,
      });

      toast.success("Contact shared successfully!", {
        position: "top-center",
        autoClose: 2000,
      });

      setOpenContactModal(false);
      setVisitorName("");
      setVisitorPhone("");
      setVisitorEventName("");
    } catch (error) {
      const status = error?.response?.status;

      if (status === 429) {
        toast.error("Too many requests. Please try again later.", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      const msg =
        error?.response?.data?.error ||
        "Failed to share contact. Please try again.";

      toast.error(msg, {
        position: "top-center",
        autoClose: 2000,
      });

      console.error("Share contact error:", error);
    } finally {
      setIsSharingContact(false);
    }
  };

  const handleDownloadVCard = async () => {
    try {
      let vCard = `BEGIN:VCARD\r\nVERSION:3.0\r\n`;
      vCard += `FN:${Account.firstName} ${Account.lastName}\r\n`;
      vCard += `N:${Account.lastName};${Account.firstName};;;\r\n`;

      if (Account.profile?.occupation) {
        vCard += `TITLE:${Account.profile.occupation}\r\n`;
      }

      // Add organization if available
      if (Account.profile?.organization) {
        vCard += `ORG:${Account.profile.organization}\r\n`;
      }

      // Handle profile picture
      if (Account.profile?.profilePicture) {
        try {
          const response = await fetch(Account.profile.profilePicture);
          if (response.ok) {
            const blob = await response.blob();
            const contentType = blob.type;
            const imageType = contentType.split("/")[1]?.toUpperCase();

            if (["JPEG", "JPG", "PNG", "GIF"].includes(imageType)) {
              const reader = new FileReader();
              reader.onload = function (e) {
                const base64Data = e.target.result.split(",")[1];
                vCard += `PHOTO;ENCODING=BASE64;TYPE=${imageType}:${base64Data}\r\n`;
              };
              reader.readAsDataURL(blob);
            }
          }
        } catch (error) {
          console.warn("Could not fetch profile picture for vCard:", error);
        }
      }

      // Add contact information
      Account.contacts?.forEach((contact) => {
        const cleanValue = contact.contactInfo?.trim();
        if (!cleanValue || cleanValue.startsWith("data:application/pdf"))
          return;

        const cleanTel = cleanValue.replace(/[^0-9+]/g, "");
        const cleanWa = cleanValue.replace(/[^0-9]/g, "");

        switch (contact.category?.toLowerCase()) {
          case "tel":
          case "phone":
          case "phonenumber":
            vCard += `TEL;TYPE=WORK,VOICE:${cleanTel}\r\n`;
            break;
          case "mailto":
          case "email":
          case "gmail":
            vCard += `EMAIL;TYPE=WORK:${cleanValue}\r\n`;
            break;
          case "map":
          case "location":
          case "address":
            vCard += `ADR;TYPE=WORK:;;${cleanValue.replace(
              /\n/g,
              "\\n",
            )};;;;\r\n`;
            vCard += `URL;TYPE=Map:https://maps.google.com/?q=${encodeURIComponent(
              cleanValue,
            )}\r\n`;
            break;
          case "wa":
          case "whatsapp":
            vCard += `URL;TYPE=WhatsApp:https://wa.me/${cleanWa}\r\n`;
            break;
          case "sms":
            vCard += `TEL;TYPE=CELL,SMS:${cleanTel}\r\n`;
            break;
          case "website":
            vCard += `URL:${cleanValue}\r\n`;
            break;
        }
      });

      // Add social links
      SocialLinks?.forEach((link) => {
        if (link.linkUrl?.trim()) {
          vCard += `URL:${link.linkUrl.trim()}\r\n`;
        }
      });

      // Add custom links
      CustomLinks?.forEach((link) => {
        if (link.linkUrl?.trim()) {
          vCard += `URL:${link.linkUrl.trim()}\r\n`;
        }
      });

      // Add current profile URL
      vCard += `URL:${window.location.href}\r\n`;

      // Add note
      const note = `Digital business card from Contactie.com - Connect with ${Account.firstName} ${Account.lastName}`;
      vCard += `NOTE:${note}\r\n`;

      // Add revision date and end
      vCard += `REV:${new Date().toISOString().replace(/[-:.]/g, "")}Z\r\n`;
      vCard += `END:VCARD`;

      // Create and download the vCard file
      const blob = new Blob([vCard], { type: "text/vcard;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const linkElement = document.createElement("a");
      linkElement.href = url;

      const safeFilename = `${Account.firstName}-${Account.lastName}-contact`
        .toLowerCase()
        .replace(/[^a-z0-9\-]/g, "_");
      linkElement.download = `${safeFilename}.vcf`;

      document.body.appendChild(linkElement);
      linkElement.click();
      document.body.removeChild(linkElement);
      URL.revokeObjectURL(url);

      toast.success("Contact card downloaded successfully!", {
        position: "top-center",
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error generating vCard:", error);
      toast.error("Failed to generate contact card.", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  // dynamic meta content for SEO and sharing
  const meta = useMemo(() => {
    if (!Account || !Account.firstName) {
      return {
        title: "User Profile | Contactie",
        description: "View user profiles and connect on Contactie.",
      };
    }

    const name = `${Account.firstName} ${Account.lastName}`;
    let description = `Explore the professional profile of ${name}`;

    if (Account.profile?.occupation) {
      description += `, a ${Account.profile.occupation}`;
    }
    if (Account.profile?.country) {
      description += ` based in ${Account.profile.country}`;
    }

    description += ". View reputation, Rate, and get in touch on Contactie.";

    return {
      title: `${name} | Contactie Profile`,
      description: description,
    };
  }, [Account]);

  // Structured Data for Google Rich Snippets
  const structuredData = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "Person",
      name: `${Account.firstName} ${Account.lastName}`,
      url: window.location.href,
      image: Account.profile?.profilePicture || undefined,
      jobTitle: Account.profile?.occupation || undefined,
      worksFor: Account.profile?.organization || undefined,
      sameAs: SocialLinks?.map((link) => link.linkUrl).filter(Boolean) || [],
    }),
    [Account, SocialLinks],
  );

  return (
    <>
      <Helmet>
        {/* <!-- Standard SEO Tags --> */}
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <link rel="canonical" href={window.location.href} />

        {/* <!-- Open Graph / Facebook / LinkedIn --> */}
        <meta property="og:type" content="profile" />
        <meta property="og:site_name" content="Contactie" />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:url" content={window.location.href} />
        {/* For best results, your og:image should be 1200x630 pixels. */}
        {Account.profile?.profilePicture && (
          <meta property="og:image" content={Account.profile.profilePicture} />
        )}
        {/* Open Graph profile-specific tags */}
        <meta property="profile:first_name" content={Account.firstName} />
        <meta property="profile:last_name" content={Account.lastName} />
        {Account.profile?.userName && (
          <meta
            property="profile:username"
            content={Account.profile.userName}
          />
        )}

        {/* <!-- Twitter Card --> */}
        {/* Using "summary_large_image" is best for profile pictures. */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        {/* TODO: Use your site's main Twitter handle here (e.g., @contactie) */}
        <meta name="twitter:site" content="@contactie" />
        {Account.profile?.profilePicture && (
          <meta name="twitter:image" content={Account.profile.profilePicture} />
        )}

        {/* <!-- Structured Data (JSON-LD) for Google Rich Snippets --> */}
        {/* This tells Google that this page is specifically about a "Person" */}
        {!isLoading && (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )}
      </Helmet>

      <div
        className={`profile-page-body ${
          Account.profile?.profileCoverPicture ? "has-cover" : ""
        }`}
        style={{
          backgroundImage: Account.profile?.profileCoverPicture
            ? `url(${Account.profile.profileCoverPicture})`
            : "none",
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <CircularProgress size={60} />
            <Typography variant="h6" color="textSecondary">
              Loading Profile...
            </Typography>
          </Box>
        ) : (
          <div className="profile-content-wrapper">
            <div className="profile-container">
              {/* Profile Header Section */}
              <div className="profile-header">
                <div
                  className={`profile-pic-container ${
                    Account.role === "beta" ? "beta-user" : ""
                  }`}
                >
                  <img
                    src={
                      Account.profile.profilePicture ||
                      `https://via.placeholder.com/150/CCCCCC/FFFFFF?text=${
                        Account.firstName?.charAt(0) || ""
                      }${Account.lastName?.charAt(0) || ""}`
                    }
                    alt="Profile"
                    className="profile-pic"
                  />
                  {Account.role === "beta" && (
                    <div
                      className="beta-logo"
                      onClick={() => setOpenBetaDialog(true)}
                    >
                      🚀
                    </div>
                  )}
                </div>
                <h1 className="full-name">
                  {Account.firstName} {Account.lastName}
                </h1>
                <p className="occupation">{Account.profile.occupation}</p>

                {/* Contact Exchange Button */}
                {!sameAccount && (
                  <button
                    className="contact-exchange-button"
                    onClick={() => setOpenContactModal(true)}
                    aria-label="Contact Exchange"
                    title="Contact Exchange"
                  >
                    <i className="fas fa-user-plus"></i>
                  </button>
                )}

                {/* Share Button */}
                <button
                  className="share-button"
                  onClick={() => setOpenShareModal(true)}
                  aria-label="Share Profile"
                >
                  <i className="fas fa-share-alt"></i>
                </button>
              </div>

              {/* Tab Navigation Buttons */}
              <div className="tab-buttons">
                <button
                  className={`tab-button ${
                    activeTab === "links" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("links")}
                >
                  <i className="fas fa-link"></i>Links
                </button>
                <button
                  className={`tab-button ${
                    activeTab === "about" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("about")}
                >
                  <i className="fas fa-user"></i>About
                </button>
              </div>

              {/* Links Tab Content */}
              <div
                className={`tab-content ${
                  activeTab === "links" ? "active" : ""
                }`}
              >
                <div className="section">
                  <h3>Connect With Me</h3>
                  <ul className="links-list">
                    {SocialLinks?.filter(
                      (link) =>
                        link.category &&
                        ![
                          "tel",
                          "phone",
                          "phonenumber",
                          "wa",
                          "whatsapp",
                          "mailto",
                          "email",
                          "sms",
                          "map",
                          "location",
                          "address",
                        ].includes(link.category.toLowerCase()),
                    ).map((link) => (
                      <li key={link.id} className="link-item">
                        <a
                          href={link.linkUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick(
                              link.id,
                              link.linkUrl,
                              link.category,
                            );
                          }}
                        >
                          <i className={getSocialIcon(link.category)}></i>
                          {link.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Custom Links Section */}
                {CustomLinks && CustomLinks.length > 0 && (
                  <div className="section">
                    <h3>My Links</h3>
                    <ul className="links-list">
                      {CustomLinks.map((link) => (
                        <li key={link.id} className="link-item">
                          <a
                            href={link.linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              e.preventDefault();
                              handleLinkClick(link.id, link.linkUrl, "custom");
                            }}
                          >
                            {link.icon ? (
                              <img
                                src={link.icon}
                                alt={link.title}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  marginRight: "15px",
                                  borderRadius: "3px",
                                }}
                              />
                            ) : (
                              <i className="fas fa-link"></i>
                            )}
                            {link.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {hasValidContacts && (
                  <div className="section">
                    <h3>Get In Touch</h3>
                    <ul className="links-list">
                      {Account.contacts
                        ?.filter(
                          (contact) =>
                            contact.isPublic &&
                            !contact.contactInfo?.startsWith(
                              "data:application/pdf",
                            ),
                        )
                        .map((contact) => (
                          <li key={contact.id} className="link-item">
                            <button
                              className="contact-button"
                              onClick={() => {
                                handleContactClick(
                                  contact.category,
                                  contact.contactInfo,
                                );
                              }}
                            >
                              <i
                                className={getContactIcon(contact.category)}
                              ></i>
                              {getContactLabel(
                                contact.category,
                                contact.contactInfo,
                                contact.title,
                              )}
                            </button>
                          </li>
                        ))}
                    </ul>
                  </div>
                )}

                <div className="section">
                  <button
                    className="vcard-button"
                    onClick={handleDownloadVCard}
                  >
                    <i className="fas fa-address-card"></i>
                    Save Contact (vCard)
                  </button>
                </div>
              </div>

              {/* About Tab Content */}
              <div
                className={`tab-content ${
                  activeTab === "about" ? "active" : ""
                }`}
              >
                <div className="section">
                  <div className="about-content">
                    <p>
                      <strong>Professional:</strong>{" "}
                      {Account.profile.occupation || "Not specified"}
                    </p>
                    {Account.profile.country && (
                      <p>
                        <strong>Location:</strong> {Account.profile.country}
                      </p>
                    )}
                    {Account.category && (
                      <p>
                        <strong>Category:</strong> {Account.category}
                      </p>
                    )}
                    {/* <p>
Welcome to my profile! I'm {Account.firstName}{" "}
{Account.lastName},
{Account.profile.occupation &&
` working as a ${Account.profile.occupation}`}
{Account.profile.country &&
` based in ${Account.profile.country}`}
. Feel free to connect with me through the links above or
get in touch directly.
</p> */}
                  </div>
                </div>

                {/* Profile Overview - Only show for Freelancer and Business */}
                {(Account.category === "Freelance" ||
                  Account.category === "Business") && (
                  <div className="section">
                    <h3>Profile Overview</h3>
                    <div className="subsection">
                      <h4>Global Rating</h4>
                      <div className="stars">{generateStars(Account.rate)}</div>
                      <span id="globalRatingText">
                        {Account.rate.toFixed(1)} out of 5 ({Account.rateCount}{" "}
                        {Account.rateCount === 1 ? "review" : "reviews"})
                      </span>

                      {!sameAccount && (
                        <div className="rating-actions">
                          <LoadingButton
                            className="rating-action-button"
                            loading={isRatingLoading}
                            onClick={() => {
                              // Any logged-in user can give a rating
                              if (!profile) {
                                setOpenAuthDialog(true);
                                return;
                              }
                              setOpenRatingDialog(true);
                            }}
                            startIcon={<i className="fas fa-star"></i>}
                          >
                            Rate Me
                          </LoadingButton>
                          <LoadingButton
                            className="rating-action-button"
                            loading={isReserveLoading}
                            onClick={() => {
                              if (!profile) {
                                setOpenAuthDialog(true);
                                return;
                              }
                              setOpenReserveDialog(true);
                            }}
                            startIcon={<i className="fas fa-ticket-alt"></i>}
                          >
                            Reserve Coupon
                          </LoadingButton>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Detailed Skills - Only show for Freelancer and Business */}
                {(Account.category === "Freelance" ||
                  Account.category === "Business") && (
                  <div className="section">
                    <h3>Detailed Rating</h3>
                    <div className="detailed-skills subsection">
                      <ul>
                        <li>
                          <div className="skill-item">
                            <i className="fas fa-star"></i>
                            <span>Quality of Work</span>
                          </div>
                          <div className="stars">
                            {generateStars(Account.rate_Skill_QualityOfWork)}
                          </div>
                        </li>
                        <li>
                          <div className="skill-item">
                            <i className="fas fa-hand-holding-usd"></i>
                            <span>Cost-Effectiveness</span>
                          </div>
                          <div className="stars">
                            {generateStars(
                              Account.rate_Skill_CostEffectiveness,
                            )}
                          </div>
                        </li>
                        <li>
                          <div className="skill-item">
                            <i className="fas fa-hourglass-half"></i>
                            <span>Timeliness</span>
                          </div>
                          <div className="stars">
                            {generateStars(Account.rate_Skill_Timeliness)}
                          </div>
                        </li>
                        <li>
                          <div className="skill-item">
                            <i className="fas fa-comments"></i>
                            <span>Communication</span>
                          </div>
                          <div className="stars">
                            {generateStars(Account.rate_Skill_Communication)}
                          </div>
                        </li>
                        <li>
                          <div className="skill-item">
                            <i className="fas fa-rocket"></i>
                            <span>Agility</span>
                          </div>
                          <div className="stars">
                            {generateStars(Account.rate_Skill_Agility)}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}

                {/* Rating History Section - Only show for Freelancer and Business */}
                {(Account.category === "Freelance" ||
                  Account.category === "Business") && (
                  <div className="section ">
                    <h3>Rating History</h3>
                    <div className="subsection rating-history-section">
                      {!showRatingHistory ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            setShowRatingHistory(true);
                            fetchRatingHistory();
                          }}
                          sx={{
                            backgroundColor: "#2c3e50",
                            "&:hover": { backgroundColor: "#34495e" },
                            borderRadius: "8px",
                            textTransform: "none",
                            fontSize: "16px",
                            padding: "10px 20px",
                          }}
                        >
                          <i
                            className="fas fa-history"
                            style={{ marginRight: "8px" }}
                          ></i>
                          View Rating History
                        </Button>
                      ) : (
                        <div className="rating-history-content">
                          {ratingHistoryLoading &&
                          ratingHistory.length === 0 ? (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                py: 3,
                              }}
                            >
                              <CircularProgress />
                            </Box>
                          ) : ratingHistory.length === 0 ? (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ textAlign: "center", py: 3 }}
                            >
                              No ratings found yet.
                            </Typography>
                          ) : (
                            <>
                              {(() => {
                                const chunkSize = isMobile ? 1 : 2;
                                return (
                                  <>
                                    <div className="carousel-wrapper">
                                      <Swiper
                                        modules={[Navigation, Pagination]}
                                        spaceBetween={30}
                                        slidesPerView={1}
                                        navigation={{
                                          prevEl: ".swiper-button-prev",
                                          nextEl: ".swiper-button-next",
                                        }}
                                        pagination={{
                                          type: "fraction",
                                          el: ".swiper-pagination-custom",
                                        }}
                                        onReachEnd={handleReachEnd}
                                        className="reviews-carousel"
                                      >
                                        {chunkArray(
                                          ratingHistory,
                                          chunkSize,
                                        ).map((ratingPair, index) => (
                                          <SwiperSlide key={index}>
                                            <div className="slide-content-wrapper">
                                              {ratingPair.map((rating) => (
                                                <Card
                                                  key={
                                                    rating.couponId ||
                                                    rating.useDate
                                                  }
                                                  sx={{
                                                    border: "1px solid #e0e0e0",
                                                  }}
                                                >
                                                  <CardContent>
                                                    <Box
                                                      sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        mb: 2,
                                                      }}
                                                    >
                                                      <Avatar
                                                        src={
                                                          rating.customer
                                                            ?.profilePicture
                                                        }
                                                        alt={
                                                          rating.customer
                                                            ?.firstName
                                                        }
                                                        sx={{
                                                          width: 40,
                                                          height: 40,
                                                          mr: 2,
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          (window.location.href = `/profile/${rating.customer?.userName}`)
                                                        }
                                                      />
                                                      <Box
                                                        sx={{
                                                          flexGrow: 1,
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="subtitle2"
                                                          fontWeight="bold"
                                                          sx={{
                                                            cursor: "pointer",
                                                            color: "#000",
                                                            "&:hover": {
                                                              color: "#f0ad4e",
                                                              textDecoration:
                                                                "underline",
                                                            },
                                                          }}
                                                          onClick={() =>
                                                            (window.location.href = `/profile/${rating.customer?.userName}`)
                                                          }
                                                        >
                                                          {
                                                            rating.customer
                                                              ?.firstName
                                                          }{" "}
                                                          {
                                                            rating.customer
                                                              ?.lastName
                                                          }
                                                        </Typography>
                                                        <Typography
                                                          variant="caption"
                                                          color="text.secondary"
                                                          sx={{
                                                            cursor: "pointer",
                                                            display: "block",
                                                            "&:hover": {
                                                              color: "#f0ad4e",
                                                              textDecoration:
                                                                "underline",
                                                            },
                                                          }}
                                                          onClick={() =>
                                                            (window.location.href = `/profile/${rating.customer?.userName}`)
                                                          }
                                                        >
                                                          @
                                                          {
                                                            rating.customer
                                                              ?.userName
                                                          }{" "}
                                                          •{" "}
                                                          {formatRatingDate(
                                                            rating.useDate,
                                                          )}
                                                        </Typography>
                                                      </Box>
                                                    </Box>

                                                    <Box
                                                      sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 1,
                                                        mb: 2,
                                                      }}
                                                    >
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="caption"
                                                          sx={{
                                                            minWidth: "140px",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          Quality:
                                                        </Typography>
                                                        <div className="mini-stars">
                                                          {generateStars(
                                                            rating.skill_QualityOfWork,
                                                          )}
                                                        </div>
                                                      </Box>
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="caption"
                                                          sx={{
                                                            minWidth: "140px",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          Cost-Effectiveness:
                                                        </Typography>
                                                        <div className="mini-stars">
                                                          {generateStars(
                                                            rating.skill_CostEffectiveness,
                                                          )}
                                                        </div>
                                                      </Box>
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="caption"
                                                          sx={{
                                                            minWidth: "140px",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          Timeliness:
                                                        </Typography>
                                                        <div className="mini-stars">
                                                          {generateStars(
                                                            rating.skill_Timeliness,
                                                          )}
                                                        </div>
                                                      </Box>
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="caption"
                                                          sx={{
                                                            minWidth: "140px",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          Communication:
                                                        </Typography>
                                                        <div className="mini-stars">
                                                          {generateStars(
                                                            rating.skill_Communication,
                                                          )}
                                                        </div>
                                                      </Box>
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="caption"
                                                          sx={{
                                                            minWidth: "140px",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          Agility:
                                                        </Typography>
                                                        <div className="mini-stars">
                                                          {generateStars(
                                                            rating.skill_Agility,
                                                          )}
                                                        </div>
                                                      </Box>
                                                    </Box>

                                                    {rating.comment && (
                                                      <>
                                                        <Divider
                                                          sx={{ my: 1 }}
                                                        />
                                                        <Typography
                                                          variant="body2"
                                                          sx={{
                                                            fontStyle: "italic",
                                                            color:
                                                              "text.secondary",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          "{rating.comment}"
                                                        </Typography>
                                                      </>
                                                    )}
                                                  </CardContent>
                                                </Card>
                                              ))}
                                            </div>
                                          </SwiperSlide>
                                        ))}

                                        {hasMoreRatings && (
                                          <SwiperSlide>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "100%",
                                                minHeight: "200px",
                                              }}
                                            >
                                              <CircularProgress />
                                            </Box>
                                          </SwiperSlide>
                                        )}
                                      </Swiper>

                                      <div className="swiper-controls">
                                        <div
                                          className="swiper-button-prev"
                                          ref={navigationPrevRef}
                                        ></div>{" "}
                                        <div className="swiper-pagination-custom"></div>{" "}
                                        <div
                                          className="swiper-button-next"
                                          ref={navigationNextRef}
                                        ></div>{" "}
                                      </div>
                                    </div>
                                  </>
                                );
                              })()}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* CV Section for Students, Freelancers & Businesss */}
                {["Student", "Freelance", "Business"].includes(
                  Account.category,
                ) && (
                  <div className="section">
                    <h3>
                      {Account.category === "Business"
                        ? "Pitch Deck"
                        : "Curriculum Vitae"}
                    </h3>
                    {(() => {
                      const cvContact = Account.contacts?.find(
                        (contact) =>
                          contact.category === "CvFile" && contact.isPublic,
                      );

                      if (cvContact && cvContact.contactInfo) {
                        return (
                          <div className="cv-section">
                            <div className="cv-preview">
                              <div className="cv-header">
                                <i className="fas fa-file-pdf cv-icon"></i>
                                <div className="cv-info">
                                  <h4>
                                    {cvContact.title ||
                                      (Account.category === "Business"
                                        ? "Pitch Deck"
                                        : "Curriculum Vitae")}
                                  </h4>
                                  <p>Click below to view or download.</p>
                                </div>
                              </div>
                              <div className="cv-buttons">
                                <button
                                  className="cv-button cv-preview-button"
                                  onClick={() => {
                                    // Track CV view
                                    if (
                                      profile &&
                                      profile.id &&
                                      profile.id !== Account.id
                                    ) {
                                      axios
                                        .post("/api/CVTracking/track-cv-view", {
                                          userId: Account.id,
                                          viewerUserId: profile.id,
                                          gender:
                                            profile.profile?.gender || null,
                                          country: null,
                                        })
                                        .catch((error) =>
                                          console.error(
                                            "Failed to track CV view:",
                                            error,
                                          ),
                                        );
                                    } else if (!profile || !profile.id) {
                                      axios
                                        .post("/api/CVTracking/track-cv-view", {
                                          userId: Account.id,
                                          viewerUserId: null,
                                          gender: null,
                                          country: null,
                                        })
                                        .catch((error) =>
                                          console.error(
                                            "Failed to track CV view:",
                                            error,
                                          ),
                                        );
                                    }

                                    cvFileRef.current = cvContact.contactInfo;
                                    setOpenCvDialog(true);
                                  }}
                                >
                                  <i className="fas fa-eye"></i>
                                  Preview
                                </button>

                                <button
                                  className="cv-button cv-download-button"
                                  onClick={async () => {
                                    // Track CV download
                                    if (
                                      profile &&
                                      profile.id &&
                                      profile.id !== Account.id
                                    ) {
                                      try {
                                        await axios.post(
                                          "/api/CVTracking/track-cv-download",
                                          {
                                            userId: Account.id,
                                            downloaderUserId: profile.id,
                                            gender:
                                              profile.profile?.gender || null,
                                            country: null,
                                          },
                                        );
                                      } catch (trackError) {
                                        console.error(
                                          "Failed to track CV download:",
                                          trackError,
                                        );
                                      }
                                    } else if (!profile || !profile.id) {
                                      try {
                                        await axios.post(
                                          "/api/CVTracking/track-cv-download",
                                          {
                                            userId: Account.id,
                                            downloaderUserId: null,
                                            gender: null,
                                            country: null,
                                          },
                                        );
                                      } catch (trackError) {
                                        console.error(
                                          "Failed to track CV download:",
                                          trackError,
                                        );
                                      }
                                    }

                                    try {
                                      const docName =
                                        Account.category === "Business"
                                          ? "Profile"
                                          : "CV";
                                      const filename = `${Account.firstName}_${Account.lastName}_${docName}.pdf`;
                                      // Check if it's a data URL (base64)
                                      if (
                                        cvContact.contactInfo.startsWith(
                                          "data:",
                                        )
                                      ) {
                                        // For iOS Safari compatibility, use Blob approach
                                        const response = await fetch(
                                          cvContact.contactInfo,
                                        );
                                        const blob = await response.blob();

                                        // Create object URL
                                        const url = URL.createObjectURL(blob);

                                        // Create download link
                                        const link =
                                          document.createElement("a");
                                        link.href = url;
                                        link.download = filename;

                                        // For iOS Safari, try to open in new tab as fallback
                                        if (
                                          navigator.userAgent.match(
                                            /iPhone|iPad|iPod/i,
                                          )
                                        ) {
                                          // Try download first
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);

                                          // Fallback: open in new tab after a short delay
                                          setTimeout(() => {
                                            window.open(url, "_blank");
                                          }, 100);
                                        } else {
                                          // Standard download for other browsers
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }

                                        // Clean up object URL
                                        setTimeout(
                                          () => URL.revokeObjectURL(url),
                                          1000,
                                        );
                                      } else {
                                        // For regular URLs, use direct approach
                                        const link =
                                          document.createElement("a");
                                        link.href = cvContact.contactInfo;
                                        link.download = filename;
                                        link.target = "_blank";
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                      }
                                    } catch (error) {
                                      console.error(
                                        "CV download failed:",
                                        error,
                                      );
                                      // Fallback: open in new tab
                                      window.open(
                                        cvContact.contactInfo,
                                        "_blank",
                                      );
                                    }
                                  }}
                                >
                                  <i className="fas fa-download"></i>
                                  Download
                                </button>

                                <button
                                  className="cv-button cv-analyzer-button"
                                  onClick={() => setOpenAnalyzerDialog(true)}
                                >
                                  <i className="fas fa-brain"></i>
                                  Fit Analyzer
                                </button>
                              </div>

                              <FitAnalyzerDialog
                                open={openAnalyzerDialog}
                                onClose={() => setOpenAnalyzerDialog(false)}
                                cvBase64DataUrl={cvContact.contactInfo}
                                category={Account.category}
                                candidateUserId={Account.id}
                              />
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div className="cv-section">
                            <p className="no-cv-message">
                              <i className="fas fa-info-circle"></i>
                              No{" "}
                              {Account.category === "Business"
                                ? "Pitch Deck"
                                : "curriculum vitae"}{" "}
                              has been uploaded.
                            </p>
                          </div>
                        );
                      }
                    })()}
                  </div>
                )}

                {/* Quick Connect QR Code Section */}
                <div className="section">
                  <h3>Quick Connect</h3>
                  <div className="subsection">
                    <div className="qr-section">
                      <div
                        id="profile-qrcode"
                        style={{
                          width: 150,
                          height: 150,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <StyledQRCode options={quickConnectQrOptions} />
                      </div>
                      <p className="qr-description">
                        Scan this QR code with your device to view my profile.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Share Dialog (MUI) */}
              <Dialog
                open={openShareModal}
                onClose={() => setOpenShareModal(false)}
                fullWidth
                maxWidth="xs"
              >
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: 700,
                    color: "#2c3e50",
                  }}
                >
                  Share Profile
                  <IconButton
                    aria-label="close"
                    onClick={() => setOpenShareModal(false)}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent>
                  <div className="share-options">
                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        window.location.href,
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Share on Facebook"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>

                    <a
                      href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                        window.location.href,
                      )}&text=${encodeURIComponent(
                        `Check out the profile for ${Account.firstName} ${Account.lastName} on Contactie!`,
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Share on X"
                    >
                      <i className="fab fa-x-twitter"></i>
                    </a>

                    <button
                      type="button"
                      className="share-copy-button"
                      title="Copy Profile Link"
                      aria-label="Copy Profile Link"
                      onClick={async () => {
                        try {
                          if (
                            navigator.clipboard &&
                            navigator.clipboard.writeText
                          ) {
                            await navigator.clipboard.writeText(
                              window.location.href,
                            );
                          } else {
                            const textArea = document.createElement("textarea");
                            textArea.value = window.location.href;
                            document.body.appendChild(textArea);
                            textArea.select();
                            document.execCommand("copy");
                            document.body.removeChild(textArea);
                          }

                          toast.success("Profile link copied to clipboard!", {
                            position: "top-center",
                            autoClose: 2000,
                          });
                        } catch (error) {
                          console.error("Failed to copy to clipboard:", error);
                          toast.error(
                            "Could not copy the link automatically. Please copy it manually: " +
                              window.location.href,
                            {
                              position: "top-center",
                              autoClose: 5000,
                            },
                          );
                        }
                      }}
                    >
                      <i className="fas fa-link"></i>
                    </button>
                  </div>

                  <div
                    id="qrcode"
                    style={{
                      width: 150,
                      height: 150,
                      margin: "20px auto",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <StyledQRCode
                      ref={qrCodeRef}
                      options={shareModalQrOptions}
                    />
                  </div>

                  <button id="download-qr" onClick={handleQrDownload}>
                    <i className="fas fa-download"></i> Download
                  </button>
                </DialogContent>
              </Dialog>

              {/* Contact Exchange Dialog (MUI) */}
              <Dialog
                open={openContactModal}
                onClose={() => {
                  setOpenContactModal(false);
                  setVisitorCountry(getDefaultCountry());
                }}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { maxWidth: 450 } }}
              >
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: 800,
                    color: "#2c3e50",
                  }}
                >
                  Contact Exchange
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setOpenContactModal(false);
                      setVisitorCountry(getDefaultCountry());
                    }}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                      paddingTop: 1,
                    }}
                  >
                    <TextField
                      fullWidth
                      label="Your Name"
                      variant="outlined"
                      value={visitorName}
                      onChange={(e) => setVisitorName(e.target.value)}
                      placeholder="e.g. John Doe"
                      sx={commonInputStyle}
                    />

                    <Box
                      sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}
                    >
                      <Autocomplete
                        options={visitorCountryCodes}
                        value={visitorCountry}
                        disableClearable
                        autoHighlight
                        isOptionEqualToValue={(o, v) => o.id === v.id}
                        onChange={(e, newValue) =>
                          setVisitorCountry(newValue || getDefaultCountry())
                        }
                        getOptionLabel={(o) => `${o.code}`}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            {...props}
                            key={option.id}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              py: 1,
                              fontSize: "13px",
                            }}
                          >
                            <img
                              src={option.flag}
                              alt=""
                              style={{ width: 18, height: 12, borderRadius: 2 }}
                            />
                            <span>
                              {option.country} ({option.code})
                            </span>
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Code"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  sx={{ mr: -0.5 }}
                                >
                                  <img
                                    src={visitorCountry?.flag}
                                    alt=""
                                    style={{
                                      width: 18,
                                      height: 12,
                                      borderRadius: 2,
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        sx={{
                          width: "110px",
                          flexShrink: 0,
                          ...commonInputStyle,
                        }}
                      />

                      <TextField
                        fullWidth
                        label="Phone Number"
                        type="tel"
                        value={visitorPhone}
                        onChange={(e) =>
                          setVisitorPhone(
                            e.target.value.replace(/[^\d\s\-\(\)]/g, ""),
                          )
                        }
                        placeholder="Mobile number"
                        inputProps={{ maxLength: 20 }}
                        sx={{ flex: 1, ...commonInputStyle }}
                      />
                    </Box>

                    <TextField
                      fullWidth
                      label="Event Name (Optional)"
                      variant="outlined"
                      value={visitorEventName}
                      onChange={(e) => setVisitorEventName(e.target.value)}
                      placeholder="e.g. Business Meetup"
                      inputProps={{ maxLength: 20 }}
                      helperText={`${visitorEventName.length}/20`}
                      sx={commonInputStyle}
                    />

                    <LoadingButton
                      fullWidth
                      variant="contained"
                      loading={isSharingContact}
                      onClick={handleShareVisitorContact}
                      startIcon={<i className="fas fa-paper-plane"></i>}
                      sx={{
                        py: 1.5,
                        borderRadius: "14px",
                        mt: 1,
                        backgroundColor: "#2c3e50",
                        textTransform: "none",
                        fontSize: "16px",
                        fontWeight: "bold",
                        "&:hover": { backgroundColor: "#1a252f" },
                      }}
                    >
                      Share My Contact
                    </LoadingButton>
                  </Box>
                </DialogContent>
              </Dialog>

              {/* Rating Dialog */}
              {openRatingDialog && (
                <RatingDialog
                  onClose={() => setOpenRatingDialog(false)}
                  onClick={handleSendRate}
                  openDialog={openRatingDialog}
                  serialKey={SerialKey}
                />
              )}

              {/* Reserve Dialog */}
              {openReserveDialog && (
                <CheckoutReserved
                  onApply={handleApplyCoupon}
                  ShowCouponSection={true}
                  onClose={(event, reason) => {
                    if (reason && reason === "backdropClick") return;
                    setOpenReserveDialog(false);
                  }}
                />
              )}

              {/* CV Preview Dialog */}
              {openCvDialog && (
                <Dialog
                  open={openCvDialog}
                  onClose={() => setOpenCvDialog(false)}
                  fullWidth
                  maxWidth="md"
                  sx={{
                    "& .MuiDialog-paper": {
                      width: "100vw",
                      height: "80vh",
                      maxWidth: "none",
                    },
                  }}
                >
                  <DialogTitle>
                    {Account.category === "Business" ? "Pitch Deck" : "CV"}{" "}
                    Preview <PortraitIcon />
                  </DialogTitle>
                  <DialogContent sx={{ height: "100%", p: 0 }}>
                    <IconButton
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                      }}
                      aria-label="close"
                      onClick={() => setOpenCvDialog(false)}
                    >
                      <CloseIcon />
                    </IconButton>
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        overflow: "auto",
                      }}
                    >
                      <Worker
                        workerUrl={`https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.min.js`}
                      >
                        <Viewer
                          fileUrl={cvFileRef.current}
                          showPreviousViewOnLoad={false}
                          defaultScale={1}
                        />
                      </Worker>
                    </div>
                  </DialogContent>
                </Dialog>
              )}

              {/* Beta Dialog */}
              <Dialog
                open={openBetaDialog}
                onClose={() => setOpenBetaDialog(false)}
                fullWidth
                maxWidth="sm"
              >
                <DialogTitle>
                  <Box display="flex" alignItems="center" gap={1}>
                    <span style={{ fontSize: "24px" }}>🚀</span>
                    <Typography
                      variant="h6"
                      component="span"
                      sx={{ color: "#ff715b", fontWeight: 600 }}
                    >
                      Beta Pioneer
                    </Typography>
                  </Box>
                  <IconButton
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                    }}
                    aria-label="close"
                    onClick={() => setOpenBetaDialog(false)}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Box sx={{ pt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
                      Welcome to our exclusive beta community!
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
                      Your feedback is essential in helping us create the best
                      experience. Every contribution you make helps shape the
                      future of our platform.
                    </Typography>
                    <Box
                      sx={{
                        backgroundColor: "#f8f9fa",
                        padding: 2,
                        borderRadius: 1,
                        borderLeft: "4px solid #ff715b",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: "#ff715b", fontWeight: 500 }}
                      >
                        Thank you for being part of our innovation journey! 🎉
                      </Typography>
                    </Box>
                  </Box>
                </DialogContent>
              </Dialog>
            </div>

            {!profile && (
              <a href="/signup" className="cta-container simple-cta">
                <span className="simple-cta-text">
                  Boost your reach with Contactie
                </span>
                <span className="simple-cta-arrow">
                  <i className="fas fa-arrow-right"></i>
                </span>
              </a>
            )}
          </div>
        )}
      </div>

      {/* Authentication Dialog */}
      <Dialog
        open={openAuthDialog}
        onClose={() => setOpenAuthDialog(false)}
        aria-labelledby="auth-dialog-title"
      >
        <DialogTitle id="auth-dialog-title">
          Authentication Required
          <IconButton
            aria-label="close"
            onClick={() => setOpenAuthDialog(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            To prevent fake reviews and ensure the quality of our community, you
            need to log in or create a free account.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "0 24px 16px" }}>
          <Button onClick={() => navigate("/login")}>Login</Button>
          <Button
            onClick={() => navigate("/signup")}
            variant="contained"
            autoFocus
          >
            Create Account
          </Button>
        </DialogActions>
      </Dialog>

      <AiAdDialog open={showAiDialog} onClose={() => setShowAiDialog(false)} />
    </>
  );
};

// Helper functions for icons and labels
const getSocialIcon = (category) => {
  switch (category?.toLowerCase()) {
    case "x":
    case "twitter": // Keep for backward compatibility
      return "fab fa-x-twitter";
    case "github":
      return "fab fa-github";
    case "instagram":
      return "fab fa-instagram";
    case "facebook":
      return "fab fa-facebook-f";
    case "linkedin":
      return "fab fa-linkedin-in";
    case "youtube":
      return "fab fa-youtube";
    case "tiktok":
      return "fab fa-tiktok";
    case "snapchat":
      return "fab fa-snapchat-ghost";
    case "pinterest":
      return "fab fa-pinterest";
    case "reddit":
      return "fab fa-reddit";
    case "discord":
      return "fab fa-discord";
    case "telegram":
      return "fab fa-telegram";
    case "whatsapp":
      return "fab fa-whatsapp";
    case "website":
    case "blog":
      return "fas fa-globe";
    case "portfolio":
      return "fas fa-briefcase";
    case "email":
      return "fas fa-envelope";
    default:
      return "fas fa-link";
  }
};

const getContactIcon = (category) => {
  switch (category?.toLowerCase()) {
    case "tel":
    case "phone":
      return "fas fa-phone";
    case "wa":
    case "whatsapp":
      return "fab fa-whatsapp";
    case "mailto":
    case "email":
    case "gmail":
      return "fas fa-envelope";
    case "map":
    case "location":
    case "address":
      return "fas fa-map-marker-alt";
    case "sms":
      return "fas fa-comment-sms";
    case "fax":
      return "fas fa-fax";
    case "website":
      return "fas fa-globe";
    default:
      return "fas fa-address-book";
  }
};

const getContactLabel = (category, contactInfo, title) => {
  if (!contactInfo || contactInfo.startsWith("data:application/pdf")) {
    return "";
  }
  // If we have a title, display it along with the contact info
  if (title && title.trim()) {
    // return `${title}: ${contactInfo}`;
    return title;
  }
  switch (category?.toLowerCase()) {
    case "tel":
    case "phone":
    case "phonenumber":
      return contactInfo;
    case "wa":
    case "whatsapp":
      return contactInfo;
    case "mailto":
    case "email":
    case "gmail":
      return contactInfo;
    case "map":
    case "location":
    case "address":
      return contactInfo;
    case "sms":
      return contactInfo;
    case "fax":
      return contactInfo;
    case "website":
      return contactInfo;
    default:
      return contactInfo;
  }
};

export default Profile;
